let React = require('react');
const FormatMessage = require('react-globalize').FormatMessage;

let SectionStatePrivacyRights = React.createClass({

  render : function () {
    return(
      <div className="container" id="terms-cond-div" style={{ "marginTop": "5%", "marginBottom": "5%" }}>
        <div className="row" style={{ "marginTop": "3%", "marginBottom": "2%" }}>
          <h3 className="text-center">
            <FormatMessage locale={this.props.locale} path="footer/footerStatePrivacyRight" />
          </h3>
          <hr className="small-blue" />
        </div>

        <div className="row text-justify">

          {
            this.props.locale == "es" ?
            <div className="col-md-12">
            
              <div className="row">
                <div className="col-md-12">
                  <p>
                    Para los consumidores en los EE. UU. (incluidos los de California, Colorado, Dakota del Norte, Texas, 
                    Vermont y Virginia), los residentes tienen ciertos derechos según las leyes estatales de privacidad 
                    con respecto a los datos personales que recopilamos. Si usted es residente de dichos estados, esta 
                    sección contiene las divulgaciones requeridas por ley y explica los derechos que pueden estar disponibles 
                    para usted.
                  </p>
                  <p>
                    <b>
                      Información personal que recopilamos, divulgamos y vendemos. En los 12 meses anteriores, recopilamos, 
                      divulgamos y vendimos las siguientes categorías de datos personales:
                    </b>
                  </p>
                  <p>
                    <ul style={{listStyleType: 'circle'}}>
                      <li>
                        Identificadores personales y en línea (como nombre y apellido, dirección de correo electrónico o 
                        identificadores únicos en línea);
                      </li>
                      <li>
                        Información de actividad de Internet u otra red electrónica (como historial de navegación, historial
                         de búsqueda, interacciones con un sitio web, correo electrónico, aplicación o publicidad);
                      </li>
                      <li>
                        Información de geolocalización;
                      </li>
                      <li>
                        Información audiovisual (como grabaciones de llamadas);
                      </li>
                      <li>
                      	Inferencias extraídas de la información anterior sobre sus características y preferencias previstas; y
                      </li>
                      <li>
                        Otra información sobre usted que está vinculada a la información personal anterior.
                      </li>
                    </ul>
                  </p>
                  <p>
                    <b>Categorías de Fuentes</b>
                  </p>
                  <p>
                    Recopilamos esta información personal de las siguientes categorías de fuentes:
                  </p>
                  <p>
                    <ul style={{listStyleType: 'circle'}}>
                      <li>
                        Consumidores;
                      </li>
                      <li>
                        Proveedores de servicios;
                      </li>
                      <li>
                        Afiliados no bajo la marca Barri; y
                      </li>
                      <li>
                        Proveedores de datos y análisis.
                      </li>
                    </ul>
                  </p>
                  <p>
                    <b>
                      Nuestros propósitos para el procesamiento de datos personales
                    </b>
                  </p>
                  <p>
                    Usamos y divulgamos la información personal que recopilamos para nuestros fines comerciales y comerciales, 
                    como se describe con más detalle en las secciones "Uso de la información" y "Compartir información" de este 
                    aviso de privacidad.
                  </p>
                  <p>
                    <b>
                      Destinatarios de Información Personal
                    </b>
                  </p>
                  <p>
                    Vendemos, incluso compartiendo con fines publicitarios dirigidos, las categorías de información personal 
                    designadas anteriormente a las categorías de terceros que se enumeran a continuación:
                  </p>
                  <p>
                    <ul style={{listStyleType: 'circle'}}>
                      <li>
                        Empresas de publicidad/mercadeo;
                      </li>
                      <li>
                        Redes publicitarias; y
                      </li>
                      <li>
                        Otras empresas que puedan comercializarle.
                      </li>
                      <li>
                        Divulgamos las categorías de información personal designadas anteriormente a las categorías 
                        de terceros que se enumeran a continuación para los fines comerciales de Barri:
                      </li>
                      <li>
                        Proveedores de servicios, como proveedores de análisis y alojamiento;
                      </li>
                      <li>
                        Afiliados no bajo la marca Barri; y
                      </li>
                      <li>
                        Empresas de publicidad/marketing que apoyan los esfuerzos publicitarios de Barri.
                      </li>
                    </ul>
                  </p>
                  <p>
                    <b>
                      Sus Derechos:
                    </b>
                  </p>
                  <p>
                    Los residentes de ciertos estados tienen derechos con respecto a la información personal recopilada 
                    por las empresas. Es posible que pueda ejercer los siguientes derechos con respecto a su información personal, sujeto a ciertas excepciones y limitaciones:
                  </p>
                  <p>
                    <ul style={{listStyleType: 'circle'}}>
                      <li>
                        El derecho a confirmar si estamos procesando datos personales sobre usted.
                      </li>
                      <li>
                        El derecho a corregir imprecisiones en los datos personales que hemos recopilado sobre usted.
                      </li>
                      <li>
                        El derecho a conocer las categorías y piezas específicas de información personal que recopilamos, 
                        usamos, divulgamos y vendemos sobre usted; las categorías de fuentes de las que recopilamos información 
                        personal, nuestros propósitos para recopilar o vender información personal, las categorías de información 
                        personal que hemos vendido o divulgado con fines comerciales; y las categorías de terceros con los que 
                        hemos compartido información personal.
                      </li>
                      <li>
                        El derecho a solicitar que eliminemos la información personal que hemos recopilado sobre usted.
                      </li>
                      <li>
                        El derecho a optar por no compartir datos personales para publicidad dirigida y otras ventas de 
                        datos personales. Tenga en cuenta que, si opta por no participar en ciertas prácticas, es posible 
                        que no podamos brindarle algunos servicios. Además, no vendemos ni compartimos a sabiendas datos 
                        personales de personas menores de 16 años.
                      </li>
                      <li>
                        El derecho a no recibir un trato discriminatorio por el ejercicio de los anteriores derechos de privacidad.
                      </li>
                    </ul>
                  </p>
                  <p>
                    <b>
                      Para ejercer cualquiera de los derechos anteriores, comuníquese con nosotros utilizando la siguiente 
                      información y envíe la información de verificación requerida, como se describe a continuación:
                    </b>
                  </p>
                  <p>
                    <ol>
                      <li>
                        Póngase en contacto con Barri a través de la sección "<a href='/clientService'>CONTÁCTENOS</a>" 
                      </li>
                      <li>
                        Acceder, eliminar y corregir su información personal y cambiar sus opciones:
                      </li>
                      <ul style={{listStyleType: 'circle'}}>
                        <li>
                          <a target="_blank" href="/documents/Do_not_sell_my_personal_information_2023.pdf">No vender mi información personal</a>
                        </li>
                        <li>
                          <a target="_blank" href="/documents/Important_Privacy_Choices.pdf">Opciones de privacidad importantes para los clientes</a>
                        </li>
                        <li>
                          <a target="_blank" href="/documents/Consent_to_Share_Personal_Information.pdf">Consentimiento para compartir información personal</a>
                        </li>
                      </ul>
                    </ol>
                  </p>
                </div>
              </div>
            </div> 
            
            :
            
            <div className="col-md-12">
            
              <div className="row">
                <div className="col-md-12">
                  <p>
                    For consumers in the USA, (including those in California, Colorado, North Dakota, Texas, Vermont, and Virginia) 
                    residents have certain rights under state privacy laws with respect to personal data we collect.  If you are a 
                    resident of such states, this section contains disclosures required by law and explains rights that may be 
                    available to you. 
                  </p>
                  <p>
                    <b>
                      Personal Information We Collect, Disclose, and Sell. In the preceding 12 months, we collected, disclosed, 
                      and sold the following categories of personal data: 
                    </b>
                  </p>
                  <p>
                    <ul style={{listStyleType: 'circle'}}>
                      <li>
                        Personal and online identifiers (such as first and last name, email address, or unique online identifiers);
                      </li>
                      <li>
                        Internet or other electronic network activity information (such as browsing history, search history, 
                        interactions with a website, email, application, or advertisement);
                      </li>
                      <li>
                        Geolocation information;
                      </li>
                      <li>
                        Audiovisual information (such as call recordings); 
                      </li>
                      <li>
                      	Inferences drawn from the above information about your predicted characteristics and preferences; and 
                      </li>
                      <li>
                        Other information about you that is linked to the personal information above.
                      </li>
                    </ul>
                  </p>
                  <p>
                    <b>Categories of Sources</b>
                  </p>
                  <p>
                    We collect this personal information from the following categories of sources:
                  </p>
                  <p>
                    <ul style={{listStyleType: 'circle'}}>
                      <li>
                        Consumers;
                      </li>
                      <li>
                        Service providers;
                      </li>
                      <li>
                        Affiliates not under the Barri brand; and
                      </li>
                      <li>
                        Data and analytics providers.
                      </li>
                    </ul>
                  </p>
                  <p>
                    <b>
                      Our Purposes for Processing Personal Data
                    </b>
                  </p>
                  <p>
                    We use and disclose the personal information we collect for our commercial and business purposes, 
                    as further described in the “Information Use” and “Information Sharing” sections of this privacy notice. 
                  </p>
                  <p>
                    <b>
                      Recipients of Personal Information 
                    </b>
                  </p>
                  <p>
                    We sell, including by sharing for targeted advertising purposes, the categories of personal 
                    information designated above to the categories of third parties listed below:
                  </p>
                  <p>
                    <ul style={{listStyleType: 'circle'}}>
                      <li>
                        Advertising/marketing companies;
                      </li>
                      <li>
                        Advertising networks; and
                      </li>
                      <li>
                        Other companies that may market to you.
                      </li>
                      <li>
                        We disclose the categories of personal information designated above to the categories 
                        of third parties listed below for Barri’s business purposes:
                      </li>
                      <li>
                        Service providers, such as analytics and hosting providers;
                      </li>
                      <li>
                        Affiliates not under the Barri brand; and
                      </li>
                      <li>
                        Advertising/marketing companies that support Barri’s advertising efforts.
                      </li>
                    </ul>
                  </p>
                  <p>
                    <b>
                     Your Rights:
                    </b>
                  </p>
                  <p>
                    Residents of certain states have rights with respect to the personal information collected by businesses. 
                    You may be able to exercise the following rights regarding your personal information, subject to certain 
                    exceptions and limitations:
                  </p>
                  <p>
                    <ul style={{listStyleType: 'circle'}}>
                      <li>
                        The right to confirm whether we are processing personal data about you. 
                      </li>
                      <li>
                        The right to correct inaccuracies in the personal data we have collected about you. 
                      </li>
                      <li>
                        The right to know the categories, and specific pieces of personal information we collect, use, 
                        disclose, and sell about you; the categories of sources from which we collected personal information, 
                        our purposes for collecting or selling personal information, the categories of personal information 
                        that we have sold or disclosed for a business purpose; and the categories of third parties with which 
                        we have shared personal information.
                      </li>
                      <li>
                        The right to request that we delete the personal information we have collected about you.
                      </li>
                      <li>
                        The right to opt-out of the sharing of personal data for targeted advertising and other sales 
                        of personal data. Please note that if you opt-out of certain type’s practices, we may be unable 
                        to provide you with some services.  Additionally, we do not knowingly sell or share the personal 
                        data of individuals under 16. 
                      </li>
                      <li>
                        The right not to receive discriminatory treatment for the exercise of the above privacy rights.
                      </li>
                    </ul>
                  </p>
                  <p>
                    <b>
                      To exercise any of the above rights, please contact us using the following information and submit the 
                      required verifying information, as further described below:
                    </b>
                  </p>
                  <p>
                    <ol>
                      <li>
                        Please contact Barri through the section titled “<a href='/clientService'>CONTACT US</a>” 
                      </li>
                      <li>
                        Accessing, deleting and correcting your personal information and changing your choices:
                      </li>
                      <ul style={{listStyleType: 'circle'}}>
                        <li>
                          <a target="_blank" href="/documents/Do_not_sell_my_personal_information_2023.pdf">Do Not Sell My Personal </a>
                        </li>
                        <li>
                          <a target="_blank" href="/documents/Important_Privacy_Choices.pdf">Important Privacy Choices for Customers</a>  
                        </li>
                        <li>
                          <a target="_blank" href="/documents/Consent_to_Share_Personal_Information.pdf">Consent to Share Personal Information</a>   
                        </li>
                      </ul>
                    </ol>
                  </p>
                </div>
              </div>
            </div>
            
          }
        </div>


      </div>
    )
  }

})

export default SectionStatePrivacyRights;


// WEBPACK FOOTER //
// ./js/sectionStatePrivacyRights.js